import type { InternalDropdownOption } from '~/chords/Select/components/DropdownTreeSingleSelect/types';

interface UpdateOptions {
  isSelected: boolean;
  indexPath?: number[];
}

/**
 * Recursively set hasSelected=true|false for the previously selected option's parents
 * and set isSelected=true|false for the previously selected option.
 * @param options - The options to update.
 * @param param1.isSelected - Boolean value to set for isSelected.
 * @param param1.indexPath - The index path of the option to update.
 * @returns The updated options array.
 */
export function updateSelectedRecursive(
  options: InternalDropdownOption[],
  { isSelected, indexPath }: UpdateOptions,
): InternalDropdownOption[] {
  if (!indexPath?.length) {
    return options;
  }

  const [currentIndex, ...restPath] = indexPath;

  return options.map((option, index): InternalDropdownOption => {
    if (index !== currentIndex) {
      return option;
    }

    if (!restPath.length) {
      return { ...option, isSelected };
    }

    return {
      ...option,
      children: option.children
        ? updateSelectedRecursive(option.children, {
            isSelected,
            indexPath: restPath,
          })
        : undefined,
      hasSelected: isSelected,
    };
  });
}
